import * as React from 'react';

class SelectAgGridEditor extends React.Component {
  state = {
    selected: false,
  };

  componentDidMount() {
    const {value} = this.props;

    this.setState({selected: value.key})
  }

  getValue = () => {
    const {values} = this.props;
    const {selected} = this.state;

    let select = null;
    values.map((val) => {
      if (val.key === +selected) {
        select = val;
      }
    });
    return select;
  };

  onChange = (e) => {
    const {agGridReact, node, values, column} = this.props;
    const {currentValuesChanges} = agGridReact.props;
    let data = node.data;

    let selected = null;
    values.map((val) => {
      if (val.key === +e.target.value) {
        selected = val.key;
      }
    });

    data[column.colId] = e.target.value;
    currentValuesChanges(data);
    this.setState({selected})
  };

  render() {
    const {values} = this.props;
    const {selected} = this.state;

    let select = null;
    values.map((val) => {
      if (val.key === selected) {
        select = val;
      }
    });
    return selected && (
      <select value={select.key} onChange={e => this.onChange(e)}>
        {values.map((val, i) => {
          return (
            <option key={i} value={val.key}>{val.hasOwnProperty('name') && val.name || val}</option>
          )
        })}
      </select>
    ) || <p>asd</p>
  }
}

export default SelectAgGridEditor;


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/FieldRenderer/SelectAgGridEditor.js